import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import AtHomeServiceWishListCard from "src/Components/WebsiteComponents/HomePage/Cards/AtHomeServiceWishListCard";
import PackagesWishListCard from "src/Components/WebsiteComponents/HomePage/Cards/PackagesWishListCard";
import PharmaWishListCard from "src/Components/WebsiteComponents/HomePage/Cards/PharmaWishListCard";
import TestWhishListCard from "src/Components/WebsiteComponents/HomePage/Cards/TestWhishListCard";
import httpRequest from "src/helpers/httpRequest";
import qs from "qs";
import { IPaginated } from "src/types/paginated";
import { Loader } from "lucide-react";
import NoItemUI from "src/Components/NoItemUI";
import NoItemImg from "src/assets/images/not-data/no-homecare.png";
import { useNavigate } from "react-router-dom";
import InfinteScrollWrapper from "src/Components/GlobalComponents/Widget/InfinteScrollWrapper";

const data = [
  {
    id: 1,
    name: "At Home Service",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    hours: 2,
    regularPrice: 1000,
    salePrice: 800,
  },
  {
    id: 2,
    name: "At Home Service",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    hours: 1,
    regularPrice: 1000,
    salePrice: 800,
  },
  {
    id: 3,
    name: "At Home Service",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz1wmn4xyHnFvtA5PyxXD3AR8dYo5ap4DZ3A&s",
    hours: 2,
    regularPrice: 1000,
    salePrice: 800,
  },
];

interface IObj {
  _id: string;
  serviceName: string;
  image: string;
  ratingCount: number;
  averageRating: number;
  price: number;
  prescriptionRequired: boolean;
  isLiked: boolean;
  shortDescription: string;
  serviceDuration: number;
  healthCareProvider: string;
}

interface IObj2 {
  _id: string;
  serviceName: string;
  image: string;
  ratingCount: number;
  averageRating: number;
  price: number;
  prescriptionRequired: boolean;
  isLiked: boolean;
  shortDescription: string;
  serviceDuration: number;
  healthCareProvider: string;
}
interface IResponse {
  documents: IObj2[];
  paginated: IPaginated;
}

const AtHomeServiceWhishList = ({
  onClose,
  onAppointmentClick,
}: {
  onClose: () => void;
  onAppointmentClick?: (id?: string) => void;
}) => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const [data, setData] = useState<IObj[]>([]);
  const [paginated, setPaginated] = useState<IPaginated>({
    currentPage: 1,
    totalPages: 1,
  });
  const [queryParams, setQueryParams] = useState<{
    page: number;
    limit: number;
    bool: boolean;
  }>({
    page: 1,
    limit: 10,
    bool: false,
  });

  const handleRemove = (obj: { productId: string }) => {
    setData((prev) => prev?.filter((v) => v._id !== obj?.productId));
    if (data?.length === 0) {
      handleQueryParamsChange({});
    }
  };

  const fetch = async (params: Partial<typeof queryParams>) => {
    setIsLoader(true);
    const { bool, ...actulaParams } = params;
    const { res, err } = await httpRequest<IResponse>({
      path: `/home-care-services/getfavproducts?${qs.stringify(actulaParams)}`,
    });
    if (res) {
      setData(
        res?.documents.map((item) => ({
          ...item,
          isLiked: true,
          serviceDuration: parseFloat(
            (item?.serviceDuration as unknown as string) || "0"
          ),
        })) || []
      );
      setPaginated(res?.paginated);
    } else {
      toast(err, { type: "error" });
    }
    setIsLoader(false);
  };

  const handleQueryParamsChange = (
    params: Partial<typeof queryParams>,
    reset = true
  ) => {
    let updatedParams = { ...queryParams, ...params };
    setQueryParams(updatedParams);
    if (reset) {
      setPaginated({
        currentPage: 1,
        totalPages: 1,
      });
      updatedParams.page = 1;
      setData([]);
    }
    fetch(updatedParams);
  };

  useEffect(() => {
    handleQueryParamsChange(queryParams);
  }, []);

  return (
    <>
      <InfinteScrollWrapper
        isLoading={isLoader}
        length={data?.length}
        currentPage={queryParams?.page}
        totalPages={paginated?.totalPages}
        onLoadMore={(page) => {
          handleQueryParamsChange({ page: page }, false);
        }}
        isLoadButton={true}
        noDataOptions={{
          text: "No At Home Services Found",
          text2:
            "Your at home services wishlist is empty. Explore and save services for quick access.",
          iconImagePath: NoItemImg,
          buttonOnPress: () => {
            onClose();
            navigate("/home-care");
          },
          buttonText: "Discover At Home Services",
        }}
        calculateHeight
      >
        {data?.map((d, index) => (
          <AtHomeServiceWishListCard
            key={d._id}
            data={d}
            handleRemove={() => handleRemove({ productId: d._id })}
            onAppointmentClick={onAppointmentClick}
          />
        ))}
      </InfinteScrollWrapper>
    </>
  );
};

export default AtHomeServiceWhishList;
